export function toAutoCSV(data) {
  // CSV 헤더 정의
  const headers = [
    // 메타데이터
    "projectId",
    "routeId",
    "name",
    "workType",
    "description",
    "createdAt",
    // 농기구 정보
    "equipmentId",
    "equipmentName",
    "equipmentWidth",
    "equipmentWheelbase",
    "equipmentSteerDeg",
    "equipmentTurningRadius",
    "equipmentVehicleLength",
    // 데이터 타입
    "type",
    "itemId",
    "itemName",
    // 좌표 정보
    "longitude",
    "latitude",
    "altitude",
    // 장애물 전용 필드
    "areaTypeId",
    "areaTypeName",
    "areaTypeColor",
  ];

  // CSV 데이터 배열
  const csvData = [];

  // 공통 메타데이터
  const commonData = {
    projectId: data.projectId,
    routeId: data.id,
    name: data.name,
    workType: data.workType,
    description: data.description || "",
    createdAt: data.createdAt,

    equipmentId: data.agriculturalEquipmentId,
    equipmentName: data.agriculturalEquipmentName,
    equipmentWidth: data.equipmentSpec?.width || "",
    equipmentWheelbase: data.equipmentSpec?.wheelBase || "",
    equipmentSteerDeg: data.equipmentSpec?.steeringAngle || "",
    equipmentTurningRadius: data.equipmentSpec?.turningRadius || "",
    equipmentVehicleLength: data.equipmentSpec?.vehicleLength || "",
  };

  // 1. 경로 데이터 추가 (웨이포인트)
  if (data.waypointDetails && data.waypointDetails.length > 0) {
    data.waypointDetails.forEach((point, index) => {
      csvData.push({
        ...commonData,
        type: "PATH",
        itemId: `waypoint_${index + 1}`,
        itemName: `웨이포인트 ${index + 1}`,
        longitude: point.x,
        latitude: point.y,
        altitude: point.z,

        areaTypeId: "",
        areaTypeName: "",
        areaTypeColor: "",
      });
    });
  }

  // 2. 장애물 데이터 추가
  if (data.obstacles && data.obstacles.length > 0) {
    data.obstacles.forEach((obstacle) => {
      // 각 장애물의 모든 점을 개별 행으로 추가
      obstacle.points.forEach((point, pointIndex) => {
        csvData.push({
          ...commonData,
          type: "OBSTACLE",
          itemId: obstacle.id,
          itemName: obstacle.name,
          longitude: point.x,
          latitude: point.y,
          altitude: point.z,

          areaTypeId: obstacle.areaType?.id || "",
          areaTypeName: obstacle.areaType?.typeName || "",
          areaTypeColor: obstacle.areaType?.typeColor || "",
        });
      });
    });
  }

  // CSV 문자열 생성
  let csvContent = "";

  // 헤더 추가
  csvContent += headers.join(",") + "\n";

  // 데이터 행 추가
  csvData.forEach((row) => {
    const values = headers.map((header) => {
      let value = row[header] || "";
      // CSV 특수문자 처리 (쉼표, 따옴표, 개행문자 포함시 따옴표로 감싸기)
      if (
        typeof value === "string" &&
        (value.includes(",") || value.includes('"') || value.includes("\n"))
      ) {
        value = '"' + value.replace(/"/g, '""') + '"';
      }
      return value;
    });
    csvContent += values.join(",") + "\n";
  });

  return csvContent;
}
